function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from "react";
import { SovosBox } from "mosaic-react";
import HeroBanner from "./HeroBanner";
import { mapProperties } from "../../utils";
import { useGlobalValue } from "../../state/GlobalProvider";
import styles from "./HeroBanner.module.sass";
const HeroBannerContainer = args => {
  const {
    title,
    summary,
    link,
    children
  } = args;
  const {
    i18n,
    params,
    locale,
    queries,
    fetch
  } = useGlobalValue();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const childrenElements = children && Array.isArray(children) ? children.map((spec, index) => {
    const Component = spec.component;
    const componentProps = mapProperties(spec.props, (fetch || {}).results, (fetch || {}).status, queries || [], args, params, i18n, locale);
    if (Array.isArray(componentProps.items) && componentProps.items.length === 0) {
      return /*#__PURE__*/React.createElement("div", {
        className: `placeholder ${styles["empty-content"]}`
      }, /*#__PURE__*/React.createElement("small", null, i18n`There are no results!`));
    }
    return Component && /*#__PURE__*/React.createElement(Component, _extends({
      key: index,
      modifiers: spec.modifiers
    }, componentProps));
  }).filter(c => c) : children;
  return /*#__PURE__*/React.createElement(SovosBox, {
    sx: {
      width: "100% !important",
      marginLeft: "0px !important",
      marginRight: "0px !important"
    }
  }, /*#__PURE__*/React.createElement(HeroBanner, {
    title: title,
    summary: summary,
    link: link,
    hasChildren: true,
    isCollapsed: isCollapsed,
    setIsCollapsed: setIsCollapsed
  }), !isCollapsed && /*#__PURE__*/React.createElement(SovosBox, {
    sx: {
      width: "calc(100% - 48px)",
      marginLeft: "24px",
      marginRight: "24px"
    }
  }, childrenElements));
};
export default HeroBannerContainer;